// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"433":"css/admin-app.6632","6950":"css/app.6632"}[chunkId] + ".css";
};